import vtkInteractorStyleImage from './InteractorStyleImage';
import vtkInteractorStyleManipulator from './InteractorStyleManipulator';
import vtkInteractorStyleMPRSlice from './InteractorStyleMPRSlice';
import vtkInteractorStyleRemoteMouse from './InteractorStyleRemoteMouse';
import vtkInteractorStyleTrackballCamera from './InteractorStyleTrackballCamera';

export default {
  vtkInteractorStyleImage,
  vtkInteractorStyleManipulator,
  vtkInteractorStyleMPRSlice,
  vtkInteractorStyleRemoteMouse,
  vtkInteractorStyleTrackballCamera,
};
